<template>
    <div>
        <v-card width="600" flat class="cardss">
            <v-card-text class="text-center blue white--text pa-5">
                <h4>
                    <strong>List of Products</strong> 
                </h4>
            </v-card-text>
            <v-card-text style="width:100%;">
                <v-simple-table>
                    <thead>
                        <tr>
                        <th class="text-center">Image</th>
                        <th class="text-center">Product name</th>
                        <th class="text-center">Description</th>
                        <th class="text-center">Avalible</th>
                        <th class="text-center">$$</th>
                        <th class="text-center">Details</th>
                        </tr>
                    </thead> 
                    <tbody>
                        <tr v-for="item in procutsExternal" :key="item.name">
                        <td>
                        <v-img width="50" :src="item.image"></v-img> 
                        </td> 
                        <td class="text-center">{{ item.name }}</td> 
                        <td class="text-center">{{ item.description }}</td>
                        <td class="text-center">{{ item.avalible }}</td>
                        <td class="text-center">{{ item.price }}</td>
                        <td class="text-center">
                            <v-btn color="orange" x-small outlined :to="{name: 'details', params: {id: item.id}}">
                                Show
                            </v-btn>
                            <br>
                            <v-btn x-small outlined color="red" @click="deleteProduct(item.id)">Delete</v-btn>
                        </td>
                        </tr> 
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<style>
    .cardss {
        border-radius: 0%;
        margin: 50px auto;
        display: block;
        border: solid orange 1px;
    }
</style>

<script>
import { mapState, mapActions } from "vuex";
export default {
    
data() {
    return {
        dialog: false
    }
},
created() {
    this.getProductsList();
},
methods:{
    ...mapActions(['getProductsList', 'deleteProduct'])
},
computed: {
    ...mapState(['procutsExternal'])
},


}
</script>